module.exports = __webpack_public_path__ + "static/media/poker.82a8dafa.jpg";